import { ReloadOutlined } from '@ant-design/icons'

import { pick } from '@eastcoal/common/utils/object'

import { useRemoteTableStore } from '../../Store/hooks/useStore'
import { Action } from '../Action'

export const Refresh = () => {
  const { reload } = useRemoteTableStore(state => pick(state, ['reload']))

  return (
    <Action title='刷新列表' onClick={reload}>
      <ReloadOutlined />
    </Action>
  )
}
